import { useSnak } from "../snak/SnakContext";

/** Numbered reference marker that opens the reference drawer at that entry. */
export function Ref({
  n
}: {
  n: number | number[];
}) {
  const {
    openRefs
  } = useSnak();
  const list = Array.isArray(n) ? n : [n];
  return <sup className="ml-0.5 whitespace-nowrap align-super text-[0.62em] font-medium leading-none" data-id="element-51" data-mp="29lbihyrse31o">
      {list.map((x, i) => <span key={x} data-id="element-52" data-mp="1zndw7gthmgbp" data-mpi={i}>
          <button onClick={e => {
        e.stopPropagation();
        openRefs(x);
      }} className="tabular text-[var(--s-accent)] underline underline-offset-2 transition-opacity duration-150 [text-decoration-color:color-mix(in_srgb,currentColor_40%,transparent)] hover:opacity-70" aria-label={`Reference ${x}`} data-id="element-53" data-mp="1zn4f6iqf7ji5">
            {x}
          </button>
          {i < list.length - 1 && <span className="text-[var(--s-accent)]" data-id="element-54" data-mp="3l1i8c5m7kejd">,</span>}
        </span>)}
    </sup>;
}